/**
 * Perfis de usuários padrão (Lauan e Luciano) para preenchimento rápido
 * nas seções Executante, Verificador e Responsável Técnico.
 * assinaturaUrl usa o nome do arquivo estático copiado pelo backend para o LaTeX.
 */

import type { UsuarioExterno } from '@/types/usuario';

export const USUARIO_PADRAO_LAUAN: UsuarioExterno = {
  nome: 'Lauan Rodrigues de Mattos Costa',
  funcao: 'Técnico de Planejamento',
  cargo: 'Técnico de Planejamento',
  assinaturaUrl: 'Lauan.jpg',
};

/** Descrição ampla do Luciano para exibição na Seção E e no formulário */
export const LUCIANO_FUNCAO_AMPLA =
  'Engº: Mecatrônico (Registro Nacional, 0812695127)\n' +
  'Engº: Segurança do Trabalho (Registro Nacional, 0812695127)\n' +
  'FS Engineer (TÜV Rheinland,# 25519/ 22,SIS)\n' +
  'MCEexpert® (TÜV Rheinland,# 0000068649)';

export const USUARIO_PADRAO_LUCIANO: UsuarioExterno = {
  nome: 'Luciano Pereira Siqueira',
  funcao: LUCIANO_FUNCAO_AMPLA,
  cargo: 'Engenheiro de Aplicação',
  crea: '0812695127', // Nº de Registro Nacional (exibido em REG.NAC. na capa)
  assinaturaUrl: 'Luciano.jpg',
};

export const USUARIO_PADRAO_JOAO: UsuarioExterno = {
  nome: 'Joao Carlos Oliveira Lirio',
  funcao: 'Engenharia de Aplicação',
  cargo: 'Engenharia de Aplicação',
  empresa: 'Schmersal',
  assinaturaUrl: 'JoaoCarlos.jpg',
};

export const USUARIO_PADRAO_DAVI: UsuarioExterno = {
  nome: 'Davi de Jesus da Conceição de Sousa',
  funcao: 'Engenharia de Aplicação',
  cargo: 'Engenharia de Aplicação',
  empresa: 'Schmersal',
  assinaturaUrl: 'Davi.jpg',
};

export const USUARIOS_PADRAO = {
  lauan: USUARIO_PADRAO_LAUAN,
  luciano: USUARIO_PADRAO_LUCIANO,
  joao: USUARIO_PADRAO_JOAO,
  davi: USUARIO_PADRAO_DAVI,
} as const;
